import { pf9DocOrigin } from 'app/constants'

// Documentation links
const kubernetesBaseUrl = `${pf9DocOrigin}/kubernetes`

export const ssoGroupsLink = `${kubernetesBaseUrl}/enable-sso-SAML-groups/`
